import { useCustomerIdToken } from '@hooks/customer/useCustomer';
import { NoteProps, useRecipeNotes } from '@hooks/customer/useRecipeNotes';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { gql } from 'graphql-request';
import {
  GraphQLRequestWithTokenProps,
  requestWithTokenRequired,
} from '@repo/ui/src/utils/graphql-request';
import useSWRMutation from 'swr/mutation';

interface Props {
  recipeId: string;
}

interface Arg {
  id: string;
}

export const deleteRecipeNote = gql`
  mutation DeleteRecipeNote($id: ID!) {
    deleteNote(input: { id: $id }) {
      id
    }
  }
`;
const fetcher = async (props: GraphQLRequestWithTokenProps, { arg: { id } }: { arg: Arg }) => {
  const data = await requestWithTokenRequired({
    ...props,
    variables: {
      id,
    },
  });
  return data?.deleteNote as NoteProps;
};

export const useDeleteRecipeNote = ({ recipeId }: Props) => {
  const { mutate } = useRecipeNotes({ recipeId });
  const { locale } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  return useSWRMutation(
    {
      document: deleteRecipeNote,
      locale,
      idToken,
    },
    fetcher,
    {
      onSuccess: (result) => {
        if (result?.id) {
          mutate((notes) => notes?.filter((note) => note.id !== result.id), {
            revalidate: false,
          });
        }
      },
    },
  );
};
